<template>
  <div
    class="slide-verify"
    @selectstart.prevent
  >
  <!-- :style="{ width: canvasWidth + 'px' }" -->
    <!-- 图片加载遮蔽罩 -->
    <div
      :class="{ 'img-loading': isLoading }"
      :style="{ height: canvasHeight + 'px' }"
      v-if="isLoading"
    />
    <!-- 认证成功后的文字提示 -->
    <div
      class="success-hint"
      :style="{ height: canvasHeight + 'px' }"
      v-if="verifySuccess"
    >
      {{ successHint }}
    </div>
    
    <!--前端生成-->
    <template v-if="isFrontCheck">
      <!--验证图片-->
      <canvas
        ref="canvas"
        class="slide-canvas"
        :width="canvasWidth"
        :height="canvasHeight"
      />
      <!--阻塞块-->
      <canvas
        ref="block"
        class="slide-block"
        :width="canvasWidth"
        :height="canvasHeight"
      />
    </template>
    <!--后端生成-->
    <template v-else>
      <!--验证图片-->
      <img
        ref="canvasRef"
        class="slide-canvas"
        :width="canvasWidth"
        :height="canvasHeight"
      />
      <!--阻塞块-->
      <img
        ref="blockRef"
        :class="['slide-block', { 'verify-fail': verifyFail }]"
      />
    </template>
    <!-- 滑动条 -->
    <div
      class="slider"
      :class="{
        'verify-active': verifyActive,
        'verify-success': verifySuccess,
        'verify-fail': verifyFail,
      }"
    >
      <!--滑块-->
      <div class="slider-box" :style="{ width: sliderBoxWidth }">
        <!-- 按钮 -->
        <div
          class="slider-button"
          ref="sliderButton"
          :style="{ left: sliderButtonLeft }"
        >
          <!-- 按钮图标 -->
          <div class="slider-button-icon">
            <i class="el-icon-arrow-right" style="font-size: 30px; position: absolute; top: -10px; left: -10px;"></i>
          </div>
        </div>
      </div>
      <!--滑动条提示文字-->
      <span class="slider-hint">{{ sliderHint }}</span>
      <!--刷新按钮-->
    </div>
      <!-- <div class="refresh-icon el-icon-refresh" @click="refresh">刷新</div> -->
  </div>
</template>

<script>
import { queryCaptcha } from  "@/plugins/api";

export default {
  name: 'SlideVerify',
  
  props: {
    blockLength: {
      type: Number,
      default: 42
    },
    blockRadius: {
      type: Number,
      default: 10
    },
    canvasWidth: {
      type: Number,
      default: 320
    },
    canvasHeight: {
      type: Number,
      default: 155
    },
    sliderHint: {
      type: String,
      default: "向右滑动"
    },
    accuracy: {
      type: Number,
      default: 3
    },
    imageList: {
      type: Array,
      default: () => []
    }
  },
  
  data() {
    return {
      isFrontCheck: false,
      verifyActive: false,
      verifySuccess: false,
      verifyFail: false,
      blockObj: null,
      canvasCtx: null,
      blockCtx: null,
      blockX: null,
      blockY: null,
      image: null,
      originX: null,
      originY: null,
      dragDistanceList: [],
      sliderBoxWidth: '0px',
      sliderButtonLeft: '0px',
      isMouseDown: false,
      isLoading: true,
      timestamp: null,
      successHint: '',
      nonceStr: '',
      startX: 0, // 添加起始位置
      currentX: 0 // 添加当前位置
    }
  },
  
  computed: {
    blockWidth() {
      return this.blockLength * 2
    }
  },
  
  mounted() {
    this.initDom()
    this.bindEvents()
  },
  
  beforeDestroy() {
    this.unbindEvents()
  },
  
  methods: {
    // 辅助函数
    sum(x, y) {
      return (Number(x) || 0) + (Number(y) || 0)
    },
    
    square(x) {
      return Math.pow(Number(x) || 0, 2)
    },
    
    initDom() {
      this.blockObj = this.$refs.blockRef
      if (this.isFrontCheck) {
        // this.canvasCtx = this.$refs.canvas?.getContext('2d') || null
        // this.blockCtx = this.blockObj?.getContext('2d') || null
        this.initImage()
      } else {
        this.getCaptcha()
      }
    },
    
    async getCaptcha() {
      try {
        const response = await queryCaptcha()
        const data = response
        this.nonceStr = data.nonceStr
        if (this.$refs.blockRef) {
          this.$refs.blockRef.src = data.blockSrc
          this.$refs.blockRef.style.top = data.blockY + 'px'
          this.$refs.blockRef.style.left = '0px'
        }
        if (this.$refs.canvasRef) {
          this.$refs.canvasRef.src = data.canvasSrc
        }
      } catch (error) {
        console.error('获取验证码失败:', error)
      } finally {
        this.isLoading = false
      }
    },
    
    initImage() {
      const image = this.createImage(() => {
        this.drawBlock()
        const { canvasWidth, canvasHeight } = this
        
        if (this.canvasCtx) {
          this.canvasCtx.drawImage(image, 0, 0, canvasWidth, canvasHeight)
        }
        if (this.blockCtx) {
          this.blockCtx.drawImage(image, 0, 0, canvasWidth, canvasHeight)
        }
        
        if (this.blockX && this.blockY && this.blockCtx) {
          let yAxle = this.blockY - this.blockRadius * 2
          let ImageData = this.blockCtx.getImageData(
            this.blockX,
            yAxle,
            this.blockWidth,
            this.blockWidth
          )
          
          if (this.$refs.blockRef) {
            this.$refs.blockRef.width = this.blockWidth
          }
          
          this.blockCtx.putImageData(ImageData, 0, yAxle)
        }
        
        this.isLoading = false
        this.nonceStr = "loyer"
      })
      if (image) {
        this.image = image
      }
    },
    
    createImage(onload) {
      const image = document.createElement("img")
      image.crossOrigin = "Anonymous"
      image.onload = onload
      image.onerror = () => {
        console.error('图片加载失败')
      }
      image.src = this.getImageSrc()
      return image
    },
    
    getImageSrc() {
      const len = this.imageList.length
      return len > 0
        ? this.imageList[this.getNonceByRange(0, len)]
        : `https://loyer.wang/view/ftp/wallpaper/${this.getNonceByRange(1, 1000)}.jpg`
    },
    
    getNonceByRange(start, end) {
      return Math.round(Math.random() * (end - start) + start)
    },
    
    drawBlock() {
      this.blockX = this.getNonceByRange(
        this.blockWidth + 10,
        this.canvasWidth - (this.blockWidth + 10)
      )
      this.blockY = this.getNonceByRange(
        10 + this.blockRadius * 2,
        this.canvasHeight - (this.blockWidth + 10)
      )
      this.draw(this.canvasCtx, "fill")
      this.draw(this.blockCtx, "clip")
    },
    
    draw(ctx, operation) {
      if (!ctx) return
      
      const PI = Math.PI
      const x = this.blockX || 0
      const y = this.blockY || 0
      const l = this.blockLength
      const r = this.blockRadius
      
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI)
      ctx.lineTo(x + l, y)
      ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI)
      ctx.lineTo(x + l, y + l)
      ctx.lineTo(x, y + l)
      ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true)
      ctx.lineTo(x, y)
      
      ctx.lineWidth = 2
      ctx.fillStyle = "rgba(255, 255, 255, 0.9)"
      ctx.strokeStyle = "rgba(255, 255, 255, 0.9)"
      ctx.stroke()
      ctx[operation]()
      ctx.globalCompositeOperation = "destination-over"
    },
    
    bindEvents() {
      const sliderButton = this.$refs.sliderButton
      if (!sliderButton) {
        console.error('找不到滑块按钮元素')
        return
      }
      
      // 鼠标事件
      sliderButton.addEventListener("mousedown", this.handleMouseDown)
      document.addEventListener("mousemove", this.handleMouseMove)
      document.addEventListener("mouseup", this.handleMouseUp)
      
      // 触摸事件
      sliderButton.addEventListener("touchstart", this.handleTouchStart)
      document.addEventListener("touchmove", this.handleTouchMove)
      document.addEventListener("touchend", this.handleTouchEnd)
      
      // 防止拖拽时选中文本
      sliderButton.addEventListener("dragstart", this.preventDrag)
    },
    
    unbindEvents() {
      const sliderButton = this.$refs.sliderButton
      if (sliderButton) {
        sliderButton.removeEventListener("mousedown", this.handleMouseDown)
        sliderButton.removeEventListener("touchstart", this.handleTouchStart)
        sliderButton.removeEventListener("dragstart", this.preventDrag)
      }
      document.removeEventListener("mousemove", this.handleMouseMove)
      document.removeEventListener("mouseup", this.handleMouseUp)
      document.removeEventListener("touchmove", this.handleTouchMove)
      document.removeEventListener("touchend", this.handleTouchEnd)
    },
    
    preventDrag(e) {
      e.preventDefault()
      return false
    },
    
    handleMouseDown(e) {
      e.preventDefault()
      this.startDrag(e.clientX, e.clientY)
    },
    
    handleTouchStart(e) {
      e.preventDefault()
      const touch = e.touches[0]
      this.startDrag(touch.clientX, touch.clientY)
    },
    
    handleMouseMove(e) {
      if (!this.isMouseDown) return
      e.preventDefault()
      this.duringDrag(e.clientX, e.clientY)
    },
    
    handleTouchMove(e) {
      if (!this.isMouseDown) return
      e.preventDefault()
      const touch = e.touches[0]
      this.duringDrag(touch.clientX, touch.clientY)
    },
    
    handleMouseUp(e) {
      if (!this.isMouseDown) return
      e.preventDefault()
      this.endDrag(e.clientX)
    },
    
    handleTouchEnd(e) {
      if (!this.isMouseDown) return
      e.preventDefault()
      const touch = e.changedTouches[0]
      this.endDrag(touch.clientX)
    },
    
    startDrag(clientX, clientY) {
      if (!this.checkImgSrc() || this.isLoading || this.verifySuccess) {
        return
      }
      
      this.originX = clientX
      this.originY = clientY
      this.startX = clientX
      this.isMouseDown = true
      this.timestamp = +new Date()
      this.dragDistanceList = [] // 清空轨迹数组
    },
    
    duringDrag(clientX, clientY) {
      if (!this.isMouseDown || !this.originX) {
        return
      }
      // x轴滑块可移动最大值
      let moveX = clientX - this.originX
      const maxMove = this.canvasWidth - 70
      
      // 限制移动范围
      if (moveX < 0) {
        moveX = 0
      } else if (moveX > maxMove) {
        moveX = maxMove
      }
      
      const moveY = clientY - this.originY
      
      // 更新滑块位置
      this.sliderButtonLeft = `${moveX}px`
      this.sliderBoxWidth = `${moveX}px`
      
      // 更新阻塞块位置
      if (this.$refs.blockRef) {
        let blockLeft = moveX
        this.$refs.blockRef.style.left = `${blockLeft}px`
      }
      
      this.verifyActive = true
      
      // 记录Y轴移动轨迹
      if (this.dragDistanceList.length > 200) {
        this.dragDistanceList.shift()
      }
      this.dragDistanceList.push(moveY)
    },
    
    endDrag(endX) {
      if (!this.isMouseDown) {
        return
      }
      
      this.isMouseDown = false
      
      // 检查是否移动了
      if (Math.abs(endX - this.startX) < 5) {
        this.resetSlider()
        return
      }
      
      // 开始校验
      this.isLoading = true
      this.verifyActive = false
      
      // 滑动时长
      this.timestamp = +new Date() - this.timestamp
      
      // 移动距离
      const moveLength = parseInt(this.sliderButtonLeft) || 0
      
      // 限制操作时长10S
      if (this.timestamp > 10000) {
        this.verifyFailEvent('操作超时')
        this.isLoading = false
        return
      }
      
      // 图灵测试
      const isHuman = this.turingTest()
      console.log('isHuman:', isHuman)
      if (!isHuman && this.dragDistanceList.length > 0) {
        this.verifyFail = true
        this.isLoading = false
        this.$emit("again")
        this.resetSlider()
        return
      }
      
      // 验证逻辑
      if (this.isFrontCheck) {
        const accuracy = Math.min(Math.max(this.accuracy, 1), 10)
        const spliced = Math.abs(moveLength - this.blockX) <= accuracy
        
        if (!spliced) {
          this.verifyFailEvent('验证失败')
        } else {
          this.$emit("success", { nonceStr: this.nonceStr, value: moveLength })
          this.verifySuccessEvent()
        }
      } else {
        this.$emit("success", { nonceStr: this.nonceStr, value: moveLength })
        this.verifySuccessEvent()
      }
      this.isLoading = false
    },
    
    resetSlider() {
      // 重置滑块位置
      this.sliderButtonLeft = '0px'
      this.sliderBoxWidth = '0px'
      if (this.$refs.blockRef) {
        this.$refs.blockRef.style.left = '0px'
      }
      this.verifyActive = false
    },
    
    turingTest() {
      const arr = this.dragDistanceList
      
      if (!arr || arr.length < 3) {
        return false
      }
      
      try {
        // 计算Y轴移动的波动性
        const sumY = arr.reduce((a, b) => a + Math.abs(b), 0)
        const avgY = sumY / arr.length
        
        // 计算标准差
        const variance = arr.reduce((sum, val) => {
          const diff = Math.abs(val) - avgY
          return sum + diff * diff
        }, 0) / arr.length
        
        const stdDev = Math.sqrt(variance)
        
        // 人类拖拽通常会有一定的波动
        return stdDev > 0.5 && stdDev < 30
      } catch (error) {
        console.error('图灵测试错误:', error)
        return false
      }
    },
    
    verifySuccessEvent() {
      this.isLoading = false
      this.verifySuccess = true
      const elapsedTime = (this.timestamp / 1000).toFixed(1)
      if (elapsedTime < 1) {
        this.successHint = `仅仅${elapsedTime}S，你的速度快如闪电`
      } else if (elapsedTime < 2) {
        this.successHint = `只用了${elapsedTime}S，这速度简直完美`
      } else {
        this.successHint = `耗时${elapsedTime}S，争取下次再快一点`
      }
    },
    
    verifyFailEvent(msg) {
      this.verifyFail = true
      this.$emit("fail", msg)
      setTimeout(() => {
        this.refresh()
      }, 500)
    },
    
    refresh() {
      setTimeout(() => {
        this.verifyFail = false
      }, 500)
      
      this.isLoading = true
      this.verifyActive = false
      this.verifySuccess = false
      this.resetSlider()
      
      if (this.isFrontCheck) {
        const { canvasWidth, canvasHeight } = this
        if (this.canvasCtx) {
          this.canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight)
        }
        if (this.blockCtx) {
          this.blockCtx.clearRect(0, 0, canvasWidth, canvasHeight)
        }
        if (this.$refs.blockRef) {
          this.$refs.blockRef.width = canvasWidth
        }
        if (this.image) {
          this.image.src = this.getImageSrc()
        }
      } else {
        this.getCaptcha()
      }
    },
    
    checkImgSrc() {
      if (this.isFrontCheck) {
        return true
      }
      return this.$refs.canvasRef? !!this.$refs.canvasRef.src: null
    }
  }
}
</script>

<style scoped>
/* 保持原有样式不变，添加以下样式 */
.slide-verify {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin: 0 auto;
  display: inline-block;
}

/*图片加载样式*/
.img-loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 999;
  animation: loading 1.5s infinite;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100px;
  background-color: #737c8e;
  border-radius: 5px;
}
.slider-button:active {
  cursor: grabbing;
}

@keyframes loading {
  0% {
    opacity: 0.7;
  }

  100% {
    opacity: 9;
  }
}

/*认证成功后的文字提示*/
.success-hint {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  color: #2cd000;
  font-size: large;
}

/*刷新按钮*/
.refresh-icon {
  /* position: absolute; */
  /* right: 0;
  bottom: 0;
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-size: 35px 470px; */
  /* z-index: 22; */
  color: #000;
  width: 100%;
  margin-top: 20px;
  text-align: right;
}

/*验证图片*/
.slide-canvas {
  border-radius: 5px;
}

/*阻塞块*/
.slide-block {
  position: absolute;
  left: 0;
  top: 0;
}

/*校验失败时的阻塞块样式*/
.slide-block.verify-fail {
  transition: left 0.5s linear;
}

/*滑动条*/
.slider {
  position: relative;
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 15px;
  background: #f8f8f8;
  color: #45494c;
  border: 1px solid #e4e7eb;
  border-radius: 2px;
}

/*滑动盒子*/
.slider-box {
  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  border: 0 solid #1991fa;
  background: #d1e9fe;
  /* border-radius: 5px; */
}

/*滑动按钮*/
.slider-button {
  position: absolute;
  top: -1PX;
  left: 0;
  width: 40px;
  height: 40px;
  background: #1991fa;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background 0.2s linear;
  color: #fff;
  /* border-radius: 5px; */
}

/*鼠标悬浮时的按钮样式*/
.slider-button:hover {
  background: #1991fa;
}

.slider-button:hover i {
  color: #fff;
}

/*鼠标悬浮时的按钮图标样式*/
.slider-button:hover .slider-button-icon {
  background-position: 0 -13px;
}

/*滑动按钮图标*/
.slider-button-icon {
  position: absolute;
  top: 15px;
  left: 13px;
  width: 15px;
  height: 13px;
  background-size: 35px 470px;
}


/*校验时的滑动箱样式*/
.verify-active .slider-box {
  height: 38px;
  /* border-width: 1px; */
}

/*校验成功时的滑动箱样式*/
.verify-success .slider-box {
  height: 38px;
  /* border: 1px solid #9FBFF1; */
  background-color: #DAE6FA;
}

/*校验成功时的按钮样式*/
.verify-success .slider-button {
  height: 40px;
  /* top: -1px; */
  /* border: 1px solid #0043E0; */
  background-color: #0043E0 !important;
  color: #fff;
}

/*校验成功时的按钮图标样式*/
.verify-success .slider-button-icon {
  background-position: 0 0 !important;
}

/*校验失败时的滑动箱样式*/
.verify-fail .slider-box {
  height: 38px;
  /* border: 1px solid #f57a7a; */
  background-color: #fce1e1;
  transition: width 0.5s linear;
}

/*校验失败时的按钮样式*/
.verify-fail .slider-button {
  height: 38px;
  top: -1px;
  border: 1px solid #f57a7a;
  background-color: #f57a7a !important;
  transition: left 0.5s linear;
}

/*校验失败时的按钮图标样式*/
.verify-fail .slider-button-icon {
  top: 14px;
  background-position: 0 -82px !important;
}
.slider-hint {
  font-size: 14px;
}
/*校验状态下的提示文字隐藏*/
.verify-active .slider-hint,
.verify-success .slider-hint,
.verify-fail .slider-hint {
  display: none;
}
</style>